﻿import {UISprite} from "./Tools/Base/UISprite";
import {SlotsButton} from "./SlotsButton";
import {StarterPackButton} from "./StarterPackButton";
import {UIBubbleProgress} from "./UIBubbleProgress";

export class LeftPanelManager extends UISprite {

    get activeButtons() {
        return this.buttons.filter(btn => btn.Active);
    }

    Awake() {
        super.Awake();

        this._rect = new PIXI.Rectangle();

        this.slotsBtn = this.addChild(new SlotsButton());
        this.starterPackButton = this.addChild(new StarterPackButton());
        this.bubbleProgress = this.addChild(new UIBubbleProgress());

        this.buttons = [
            this.bubbleProgress,
            this.slotsBtn,
            this.starterPackButton,
        ];
    }

    Init() {
        for (let btn of this.buttons) {
            btn.Init();
            btn.on("ActiveChanged", () => this.fitLayout());
        }
    }

    Update() {
        for (let btn of this.buttons) {
            btn.Update();
        }
    }

    fitLayout(rect = this._rect) {
        this._rect.copyFrom(rect);

        this.position.copyFrom(rect);

        let padding = rect.width * 0.1;

        let buttonRect = rect.clone();
        buttonRect.x = buttonRect.y = 0;
        buttonRect.height = buttonRect.width * 1.5;

        // DEBUG
        // this._g = (this._g || this.addChild(new PIXI.Graphics)).clear()
        //     .beginFill(0xFF0000, 0.3).drawRect(0, 0, rect.width, rect.height)
        //     .beginFill(0x0000FF, 0.3).drawRect(0, 0, buttonRect.width, buttonRect.height)
        // ;

        let activeButtons = this.activeButtons;
        for (let btn of activeButtons) {
            btn.fitLayout(buttonRect);
            buttonRect.y += buttonRect.height + padding;
        }
    }
}
